var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { usePageEntity } from '../hooks/use-page-entity';
import { SliceMainSectionLayout } from './slice-main-section-layout';
import { OrganisationMarketMapGrid } from './organisation-market-map-grid';
var cls = classNames('slice-partner-organisations-grid');
export var SlicePartnerOrganisationsGridDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var GridStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SlicePartnerOrganisationsGrid',
  Container: styled(SliceMainSectionLayout)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: styled(OrganisationMarketMapGrid)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
};
export var SlicePartnerOrganisationsGrid = function (props) {
  var componentProps = useComponentProps(My.NAME, SlicePartnerOrganisationsGridDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity;
  var activeEntity = usePageEntity();
  var partnerOrganisations = (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.partnerOrganisations) || [];
  var sliceOrganisations = (entity === null || entity === void 0 ? void 0 : entity.organisations) || [];
  if (!(partnerOrganisations === null || partnerOrganisations === void 0 ? void 0 : partnerOrganisations.length) && !(sliceOrganisations === null || sliceOrganisations === void 0 ? void 0 : sliceOrganisations.length)) {
    return null;
  }
  ;
  var organisations = (partnerOrganisations === null || partnerOrganisations === void 0 ? void 0 : partnerOrganisations.length) ? partnerOrganisations : sliceOrganisations;
  return React.createElement(My.Container, {
    className: cls.name(className),
    entity: entity
  }, React.createElement(My.Grid, {
    className: cls.name(className),
    items: organisations,
    spacing: 2,
    hasBorder: true
  }));
};
SlicePartnerOrganisationsGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;